import { DOCUMENT } from '@angular/common';
import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { AppSettingsService } from '../services/app-settings.service';
import { SessionService } from '../services/account-service/session.service';

export const securityHttpInterceptor: HttpInterceptorFn = (request, next) => {
  const settings = inject(AppSettingsService);
  const document = inject(DOCUMENT);
  const url = new URL(request.url, document.location.origin);
  const api = new URL(settings.apiPath);

  // Assets, SAS URLs and third-party requests must never receive the account token.
  if (url.origin !== api.origin || !url.pathname.startsWith(api.pathname)) {
    return next(request);
  }

  const session = inject(SessionService);
  const isAuthRequest = url.pathname.startsWith(`${api.pathname}security/`);
  const token = isAuthRequest ? undefined : session.currentToken;
  const version = session.version;
  const authenticated = token ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : request;

  return next(authenticated).pipe(tap({
    next: event => {
      if (token && event instanceof HttpResponse && (event.body as { status?: number } | null)?.status === 401) {
        session.expire(token, version);
      }
    },
    error: (error: unknown) => {
      if (token && error instanceof HttpErrorResponse && error.status === 401) {
        session.expire(token, version);
      }
    }
  }));
};
